import { FC } from 'react';
import { DataCellProps } from '../types';
import Copy from 'components/Copy';

export const TeamMemberCopyCell: FC<DataCellProps> = ({ _customRowProps, textToCopy }) => {
  return <Copy textToCopy={textToCopy} />;
};
